import API from 'services/api';

export const restoreStatement = ({ statementId }: { statementId: string }) => {
  return API.put(`api/accommodation/calculations/statements/${statementId}/restore`);
};
